const BuildingSystemModulesSection = (settings) => {
    return (
        <div className="py-4 building-system-modules">
            <div className="container">
                <div className="row">
                    <div className="col text-center">
                        <span className="section-title d-none d-md-inline-block">Critical Building</span>
                        <span className="section-title section-title-highlight">System Modules</span>
                    </div>
                </div>
                <div className="row mt-3 g-0 d-flex align-items-stretch">
                    {settings.modules.map((module, index) => (
                        <div className="col-12 col-lg-6 p-1" key={index}>
                            <div className="card h-100 building-module-card"> {/* Responsive columns */}

                                {/* Left Content (Image with Margin) */}
                                {module.image && (
                                    <div
                                        className="card-image brochure-image d-flex justify-content-start align-items-start m-2">
                                        <a href={module.brochureUrl} target="_blank" rel="noopener noreferrer">
                                            <img
                                                src={module.image}
                                                alt={module.title}
                                                className="rounded"
                                            />
                                        </a>
                                    </div>
                                )}

                                <div className="card-body d-flex flex-column">
                                    <div>
                                        <div className="card-title fw-bold">
                                            <a href={module.url} className="card-title-highlight" rel="noopener noreferrer">{module.title}</a>
                                        </div>
                                        <div className="card-text">{module.text}</div>
                                    </div>
                                    <div className="d-flex mt-auto gap-2 browse-buttons">
                                        <a href={module.brochureUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary"><img src="/img/building-system-modules/brochure.png" alt="Brochure" /></a>
                                        <a href={module.videoUrl} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary"><img src="/img/building-system-modules/video.png" alt="Video" /></a>
                                        <button className="btn btn-extra-dark" aria-expanded="false" data-bs-toggle="modal" data-bs-target="#contactUsModal">
                                            <img
                                                src="/img/building-system-modules/contact-us.png"
                                                alt="video"
                                                className="me-1"
                                            />Contact</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BuildingSystemModulesSection;